import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface ChoiceCardProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  selected: boolean;
  onSelect: () => void;
  layout?: 'stack' | 'row';
}
export function ChoiceCard({
  title,
  description,
  icon,
  selected,
  onSelect,
  layout = 'row'
}: ChoiceCardProps) {
  return <button type="button" role="radio" aria-checked={selected} onClick={onSelect} className={`group relative flex w-full items-center gap-4 rounded-2xl bg-white p-4 text-left ring-1 ring-inset transition-[box-shadow,background-color,transform] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pulse-500 active:scale-[0.99] md:p-5 ${layout === 'stack' ? 'md:flex-col md:items-start md:gap-6' : ''} ${selected ? 'bg-pulse-50 ring-2 ring-pulse-600' : 'ring-ink-200 hover:ring-ink-300 hover:shadow-soft'}`} data-id="element-671" data-mp="11r4ymbr6vy1y">
      {icon && <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl transition-colors duration-150 ${selected ? 'bg-pulse-600 text-white' : 'bg-ink-100 text-ink-700 group-hover:bg-ink-200'}`} data-id="element-672" data-mp="1vr39gugrut0n">
          {icon}
        </span>}
      <span className="min-w-0 flex-1" data-id="element-673" data-mp="2anu1gio492g8">
        <span className="block text-[15px] font-semibold text-ink-900 md:text-base" data-id="element-674" data-mp="2aolvvq5z8u4x">{title}</span>
        {description && <span className="mt-0.5 block text-sm leading-snug text-ink-500" data-id="element-675" data-mp="2emtbuism9rf2">{description}</span>}
      </span>
      <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-full ring-1 ring-inset transition-colors duration-150 ${layout === 'stack' ? 'md:absolute md:right-4 md:top-4' : ''} ${selected ? 'bg-pulse-600 ring-pulse-600' : 'bg-white ring-ink-300'}`} aria-hidden data-id="element-676" data-mp="2jlmethaa200z">
        <AnimatePresence data-id="element-677" data-mp="32e74yqyldr13">
          {selected && <motion.span initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.5,
          opacity: 0
        }} transition={{
          duration: 0.15
        }} data-id="element-678" data-mp="32f06ndip1qcd">
              <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} data-id="element-679" data-mp="ybf173q7e8db" />
            </motion.span>}
        </AnimatePresence>
      </span>
    </button>;
}